// extracted by mini-css-extract-plugin
export default {"markdown":"styles_markdown__RUu6k"};